import React from "react";
import StepThree from "./steps/StepThree";
import QRCodeImg from "../../assets/images/QRCode.png"
import DoubleRingImg from "../../assets/images/DoubleRing.png"

const MakePaymentPage = () => {

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("submit");
    }
    return(
        <div className="page-container flex flex-col">
            <div className="form-container flex-grow overflow-auto">
                <StepThree />
                <form onSubmit={handleSubmit}>
                    <>
                        {/* Bill Details */}
                        <div className="flex justify-center">
                            <div className="mt-6 bg-[#D9D9DE] rounded-lg p-6">
                                <p className="font-robot text-[#0FA968]" style={{fontWeight: "500", fontSize: "18px"}}>Bill Details</p>

                                <div className="mt-2 text-[#27272A]">
                                    <div className='grid grid-cols-[2fr_2fr]'>
                                        <div>
                                            <h3 className='text-[14px]' style={{fontWeight: "500"}}>Registration Charge:</h3>
                                        </div>
                                        <div>
                                            <span className='text-[14px] float-right' style={{fontWeight: "500"}}>50.00</span>
                                        </div>
                                    </div>
                                    <div className='grid grid-cols-[2fr_2fr]'>
                                        <div>
                                            <h3 className='text-[14px]' style={{fontWeight: "500"}}>Consultation Charge:</h3>
                                        </div>
                                        <div>
                                            <span className='text-[14px] float-right' style={{fontWeight: "500"}}>400.00</span>
                                        </div>
                                    </div>
                                    <div className='grid grid-cols-[2fr_2fr]'>
                                        <div>
                                            <h3 className='text-[14px]' style={{fontWeight: "500"}}>Service Tax:</h3>
                                        </div>
                                        <div>
                                            <span className='text-[14px] float-right' style={{fontWeight: "500"}}>0.00</span>
                                        </div>
                                    </div>
                                    <div className="mt-2 mb-2 border-b-2 border-[#92929E]"></div>
                                    <div className='grid grid-cols-[2fr_2fr]'>
                                        <div>
                                            <h3 className='text-[14px]' style={{fontWeight: "500"}}>Net Amount:</h3>
                                        </div>
                                        <div>
                                            <span className='text-[14px] float-right' style={{fontWeight: "500"}}>450.00</span>
                                        </div>
                                    </div>
                                    <div className='grid grid-cols-[2fr_2fr]'>
                                        <div>
                                            <h3 className='text-[14px]' style={{fontWeight: "500"}}>Round off Amount:</h3>
                                        </div>
                                        <div>
                                            <span className='text-[14px] float-right' style={{fontWeight: "500"}}>0.00</span>
                                        </div>
                                    </div>
                                    <div className="mt-2 mb-2 border-b-2 border-[#92929E]"></div>
                                    <div className='grid grid-cols-[2fr_2fr]'>
                                        <div>
                                            <h3 className='text-[16px]' style={{fontWeight: "700"}}>Total Payable Amount:</h3>
                                        </div>
                                        <div>
                                            <span className='text-[16px] float-right' style={{fontWeight: "700"}}>450.00</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* QRCode Section */}
                        <div className="flex justify-center mt-6">
                            <img src={QRCodeImg} className="h-[227px] w-[250px]" alt="QR Code" />
                        </div>
                        <div className="flex justify-center mt-4 mb-6">
                            <p className="text-[#42424A] text-[18px]" style={{fontWeight: "400"}}>Scan the QR code to make payment</p>
                        </div>

                        {/* Payment processing section */}
                        <div className="flex justify-center mt-4 mb-6">
                            <img src={DoubleRingImg} className="h-[110px] w-[110px]" alt="QR Code" />
                        </div>
                        <div className="flex justify-center mt-4 mb-6">
                            <p className="text-[#565661] text-[16px]" style={{fontWeight: "600"}}>Hold on. We are processing your payment.</p>
                        </div>
                        <div className="flex justify-center mt-4 mb-6">
                            <p className="text-[#E91245] text-[16px]" style={{fontWeight: "600"}}>Don’t go back to other pages</p>
                        </div>
                    </>
                </form>
            </div>
        </div>
    );
}

export default MakePaymentPage;